module.exports = __webpack_public_path__ + "static/img/gp.fa4cab3e.svg";